<template>
	<div class="page">
		<!-- Шапка сайта -->
		<header>
			<b-navbar toggleable="lg" type="dark" variant="dark" class="page__header" fixed="top">
				
				<!-- Название -->
				<b-navbar-brand href="/">Кривые</b-navbar-brand>
				
				<!-- Значок меню (маленький дисплей) -->
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				
				<!-- Элементы навигации -->
				<b-collapse id="nav-collapse" is-nav>
					<!-- Страницы -->
					<b-navbar-nav>
						<b-nav-item href="/about">Описание работы</b-nav-item>
					</b-navbar-nav>
					
					<!-- Выпадающее меню, в котором собраны страницы с кривыми -->
					<b-navbar-nav class="ml-auto">
						<b-nav-item-dropdown text="Список кривых" right>
							<b-dropdown-item href="/astroid">Астроида</b-dropdown-item>
							<b-dropdown-item href="/hyperbolic_spiral">Гиперболическая спираль</b-dropdown-item>
							<b-dropdown-item href="/cardioid">Кардиоида</b-dropdown-item>
							<b-dropdown-item href="/lemniscata_bernoulli">Лемниската Бернулли</b-dropdown-item>
							<b-dropdown-item href="/logarithmic_spiral">Логарифмическая спираль</b-dropdown-item>
							<b-dropdown-item href="/roses">Роза</b-dropdown-item>
							<b-dropdown-item href="/archimedes">Спираль Архимеда</b-dropdown-item>
							<b-dropdown-item href="/strophoid">Строфоида</b-dropdown-item>
							<b-dropdown-item href="/limacon">Улитка Паскаля</b-dropdown-item>
							<b-dropdown-item href="/epicycloid">Эпициклоида</b-dropdown-item>
							<b-dropdown-item href="#" disabled>Гипоциклоида</b-dropdown-item>
							<b-dropdown-item href="#" disabled>Эвольвента (развёртка) окружности</b-dropdown-item>
						</b-nav-item-dropdown>
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
		</header>
		
		<!-- Содержимое страницы -->
		<slot></slot>
		
		<!-- Подвал -->
	</div>
</template>

<script>
export default {
	name: 'Page'
}
</script>

<style scoped>
	header {
		margin-bottom: 20px;
		position: relative;
		z-index: 100;
		padding-top: 70px;
	}
	.page{
		padding-bottom: 100px;
	}
	.page__header{
		box-shadow: 0 0 4px black;
	}
</style>
